/**
 * 🛡️ OFFHANDS (Shields)
 *
 * Offhand equipment items (10 total)
 * Level requirements: 10-80 (increments of ~10)
 * Stat requirements: STR for heavy shields, balanced for lighter shields
 *
 * Level Distribution:
 * - Common (2): Lv 10, 15
 * - Uncommon (2): Lv 25, 30
 * - Rare (2): Lv 40, 45
 * - Epic (2): Lv 55, 60
 * - Legendary (2): Lv 75, 85
 */

export const OFFHAND = {
  // ============================================================
  // COMMON OFFHANDS (2) - Lv 10, 15
  // ============================================================
  woodenShield: {
    id: 'woodenShield',
    name: 'Wooden Shield',
    icon: '🛡️',
    slot: 'offhand',
    rarity: 'common',
    levelReq: 10,
    requirements: { STR: 10 },
    description: 'A basic wooden shield, sturdy but worn.',
    stats: {
      defense: 2,
      health: 10,
    },
  },
  brokenBuckler: {
    id: 'brokenBuckler',
    name: 'Broken Buckler',
    icon: '🛡️',
    slot: 'offhand',
    rarity: 'common',
    levelReq: 15,
    requirements: { STR: 15 },
    description: 'A small, damaged buckler that still offers some protection.',
    stats: {
      defense: 1,
      health: 12,
    },
  },

  // ============================================================
  // UNCOMMON OFFHANDS (2) - Lv 25, 30
  // ============================================================
  steelShield: {
    id: 'steelShield',
    name: 'Steel Shield',
    icon: '🛡️',
    slot: 'offhand',
    rarity: 'uncommon',
    levelReq: 25,
    requirements: { STR: 42 },
    description: 'A well-crafted steel shield.',
    stats: {
      defense: 4,
      health: 20,
    },
  },
  ironBuckler: {
    id: 'ironBuckler',
    name: 'Iron Buckler',
    icon: '🛡️',
    slot: 'offhand',
    rarity: 'uncommon',
    levelReq: 30,
    requirements: { STR: 48 },
    description: 'A solid iron buckler for quick parries.',
    stats: {
      defense: 3,
      health: 25,
    },
  },

  // ============================================================
  // RARE OFFHANDS (2) - Lv 40, 45
  // ============================================================
  dragonShield: {
    id: 'dragonShield',
    name: 'Dragon Shield',
    icon: '🐲',
    slot: 'offhand',
    rarity: 'rare',
    levelReq: 40,
    requirements: { STR: 75 },
    description: 'A shield emblazoned with a dragon emblem.',
    stats: {
      defense: 8,
      health: 45,
    },
  },
  crystalAegis: {
    id: 'crystalAegis',
    name: 'Crystal Aegis',
    icon: '💎',
    slot: 'offhand',
    rarity: 'rare',
    levelReq: 45,
    requirements: { STR: 60, INT: 45 },
    description: 'A magical shield made of living crystal.',
    stats: {
      defense: 7,
      health: 50,
    },
  },

  // ============================================================
  // EPIC OFFHANDS (2) - Lv 55, 60
  // ============================================================
  titanShield: {
    id: 'titanShield',
    name: 'Titan Shield',
    icon: '⚜️',
    slot: 'offhand',
    rarity: 'epic',
    levelReq: 55,
    requirements: { STR: 115 },
    description: 'A massive shield forged by titans.',
    stats: {
      defense: 12,
      health: 75,
    },
  },
  voidBuckler: {
    id: 'voidBuckler',
    name: 'Void Buckler',
    icon: '🌑',
    slot: 'offhand',
    rarity: 'epic',
    levelReq: 60,
    requirements: { STR: 90, INT: 50 },
    description: 'A buckler that absorbs attacks into the void.',
    stats: {
      defense: 10,
      health: 85,
    },
  },

  // ============================================================
  // LEGENDARY OFFHANDS (2) - Lv 75, 85
  // ============================================================
  aegisEternal: {
    id: 'aegisEternal',
    name: 'Aegis Eternal',
    icon: '🛡️',
    slot: 'offhand',
    rarity: 'legendary',
    levelReq: 75,
    requirements: { STR: 150 },
    description: 'An unbreakable shield blessed by the gods.',
    stats: {
      defense: 18,
      health: 130,
    },
  },
  cosmicBarrier: {
    id: 'cosmicBarrier',
    name: 'Cosmic Barrier',
    icon: '🌌',
    slot: 'offhand',
    rarity: 'legendary',
    levelReq: 85,
    requirements: { STR: 130, INT: 70 },
    description: 'A barrier woven from the fabric of space itself.',
    stats: {
      defense: 15,
      health: 150,
      evasion: 0.05,
    },
  },
};
